import { Component } from '@angular/core';
import { AbstractCo2QuestionnaireDirective } from '../abstract-co2-questionnaire.directive';

@Component({
  selector: 'app-co2-questionnaire-board',
  templateUrl: './co2-questionnaire-board.component.html',
  styleUrls: ['./co2-questionnaire-board.component.scss'],
})
export class Co2QuestionnaireBoardComponent extends AbstractCo2QuestionnaireDirective {}
